import React, { useState, useEffect } from 'react';

import styles from './raports.module.scss';

import CModal from '../../components/modal/modal';
import CButton from '../../components/button/button';
import CCollapse from '../../components/collapse/collapse';
import CSearchBar from '../../components/search-bar/search_bar';
import { Space } from '../../components/utils/utils';
import CSorting from '../../components/sort/sort';
import AddRaport from '../../components/forms/add_raports';
import { getAll, importArchive } from '../../network/raports';
import { prettyDate } from '../../utils/strings';
import { IDataPaged, IRaportFullInfo } from '../../utils/interfaces/interfaces';
import { sort_chronologically } from '../../utils/lists';
import { typesActionsRaports } from '../../types/actions-raports';
import { Pagination, Skeleton } from 'antd';
import { variables } from '../../utils/variables';
import { useGetCurrentUserQuery } from '../../api';
import {
  checkFilesHaveSameType,
  handleFileChange,
  initialFile
} from '../../utils/files';
import { notify } from '../../notifications/notification';
import { typesFiles } from '../../types/uploaded-data';
import CUpload from '../../components/input/upload';
import { importLitigations } from '../../network/litigii';
import EditReportsPermissionsModal from '../../components/forms/edit_report_permissions';

const Raports = () => {
  const [openedModal, setModal] = useState(false);
  const [openedModalFollowup, setModalFollowup] = useState(false);
  const [openedModalEdit, setModalEdit] = useState(false);
  const [openedModalAditional, setModalAditional] = useState(false);
  const [openedModalArchive, setModalArchive] = useState(false);
  const [openedModalPermissions, setModalPermissions] = useState(false);

  const [currentPage, setPage] = useState(1);

  const [selectedRaport, setSelected] = useState({} as IRaportFullInfo);
  const [filterValue, setValue] = useState('');
  const [sortValue, setSort] = useState('');
  const [raports, setRaports] = useState({} as IDataPaged);
  const [initial_raports, setInitialRaports] = useState({} as IDataPaged);

  const [document, setDocument] = useState(initialFile);

  const handleFile = (
    event: React.ChangeEvent<HTMLInputElement>,
    setFile: any
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      console.log(event.target.files);
      if (event.target.files && event.target.files.length > 0) {
        if (
          !checkFilesHaveSameType(event.target.files, typesFiles.zip) &&
          !checkFilesHaveSameType(event.target.files, typesFiles.windowsZip)
        ) {
          notify('Trebuie sa incarcati documente de tip ZIP', 'info');
          return;
        }
      }
    }
    handleFileChange(event, setFile);
  };

  const getRaports = (pageSize: number) =>
    getAll(pageSize).then(({ data }) => {
      setRaports(data);
      setInitialRaports(data);
    });

  const importZip = async () => {
    importArchive(document[0]).then(() => {
      notify('Ati importat rapoartele cu success', 'success');
      setDocument(initialFile);
      getRaports(1);
      setPage(1);
    });
  };

  const addNewArchive = () => {
    setModal(!openedModalArchive);
  };

  const addNew = () => {
    setModal(!openedModal);
  };

  const handleFilter = (event: React.ChangeEvent<any>) => {
    const { value } = event.target;
    setValue(value);
  };

  const handleSort = (key: string) => {
    setSort(key);
  };

  const callbackAdd = () => {
    getRaports(1);
    setModal(false);
  };

  const callbackAddFU = () => {
    setModalFollowup(false);
    getRaports(1);
    setPage(1);
  };

  const callbackEdit = () => {
    setModalEdit(false);
    getRaports(1);
    setPage(1);
  };

  const callbackAdditional = () => {
    setModalAditional(false);
    getRaports(1);
    setPage(1);
  };

  const callbackArchive = () => {
    setModalArchive(false);
    getRaports(1);
    setPage(1);
  };

  useEffect(() => {
    const direction = sortValue === 'up' ? 1 : -1;
    const sorted = sort_chronologically(raports.data, 'createdAt', direction);

    setRaports({ ...raports, data: sorted });
    // eslint-disable-next-line
  }, [sortValue]);

  useEffect(() => {
    getRaports(currentPage);
  }, [currentPage]);

  useEffect(() => {
    console.log(initial_raports);
    const filtered =
      initial_raports &&
      initial_raports.data &&
      initial_raports.data.filter((entry: IRaportFullInfo) => {
        const normalizedName = entry.name
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
        const normalizedWord = filterValue
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
        return (
          entry.createdAt
            .toString()
            .slice(0, 10)
            .toLowerCase()
            .includes(filterValue) ||
          prettyDate(entry.createdAt).toLowerCase().includes(filterValue) ||
          normalizedName.toLowerCase().includes(normalizedWord)
        );
      });

    setRaports({ ...raports, data: filtered });
    // eslint-disable-next-line
  }, [filterValue, initial_raports]);

  const { data: user } = useGetCurrentUserQuery();

  return (
    <div className={styles.container}>
      {raports && initial_raports && (
        <>
          <div className={styles.rowInfo}>
            <div className='column align-start '>
              <p className='subheading-dark bold'>
                Gestionare rapoarte de control
                {!user?.institution.private ? '' : ' / contracte'}
              </p>
              <p className='body-dark'>
                Ați introdus{' '}
                {initial_raports.totalRecords && initial_raports.totalRecords}{' '}
                {initial_raports.totalRecords &&
                initial_raports.totalRecords === 1
                  ? !user?.institution.private
                    ? 'raport'
                    : 'raport / contract'
                  : !user?.institution.private
                  ? 'raporte'
                  : 'raporte / contracte'}
                .
              </p>
            </div>
            <CButton
              type='button'
              label={
                !user?.institution.private
                  ? 'Adaugă raport'
                  : 'Adaugă raport / contract'
              }
              onClick={addNew}
            />
            <Space horizontal='40px' /> sau <Space horizontal='40px' />
            <CUpload
              style={{ width: '360px' }}
              endingStyle={{ top: 'auto' }}
              title={
                !user?.institution.private
                  ? 'Încărcați rapoarte'
                  : 'Încărcați rapoarte / contracte'
              }
              label=''
              id='archive'
              name=''
              value={document}
              onChange={e => handleFile(e, setDocument)}
            />
            <Space horizontal='30px' />
            <CButton type='submit' label='Importa' onClick={importZip} />
          </div>
          <div className={styles.content}>
            <div className='justify-start'>
              <CSearchBar value={filterValue} onChange={handleFilter} />
              <Space horizontal={20} />
              <CSorting value={filterValue} onChange={handleSort} />
            </div>

            {raports.data && (
              <div className={styles.list}>
                {raports.data &&
                  raports.data.length > 0 &&
                  raports.data.map((option: IRaportFullInfo) => (
                    <CCollapse
                      onAdd={() => {
                        setSelected(option);
                        setModalFollowup(true);
                      }}
                      onEdit={() => {
                        setSelected(option);
                        setModalEdit(true);
                      }}
                      onAdditionalDocument={() => {
                        setSelected(option);
                        setModalAditional(true);
                      }}
                      onDelete={() => {
                        callbackAdditional();
                        getRaports(1);
                        setPage(1);
                      }}
                      onChangePermissions={() => {
                        setSelected(option);
                        setModalPermissions(true);
                      }}
                      key={option.id}
                      id={option.id}
                      title={`${option.name} introdus pe ${prettyDate(
                        option.createdAt
                      )}`}
                      documents={raports}
                      raport={option}
                    />
                  ))}
              </div>
            )}
            {raports && raports.data && raports.data.length > 0 && (
              <div className='row center'>
                <Pagination
                  defaultCurrent={1}
                  total={raports.totalRecords}
                  current={currentPage}
                  pageSize={variables.paginationRatio}
                  onChange={e => setPage(e)}
                />
              </div>
            )}
            <Space vertical='1vh' />
          </div>
          {/*  modals for add, edit, add followup and add additional document */}
          <CModal opened={openedModal} openModal={setModal}>
            <AddRaport
              type={typesActionsRaports.ADD_RAPORT}
              callback={callbackAdd}
            />
          </CModal>
          <CModal opened={openedModalFollowup} openModal={setModalFollowup}>
            <AddRaport
              type={typesActionsRaports.ADD_FOLLOWUP}
              raport={selectedRaport}
              callback={callbackAddFU}
            />
          </CModal>
          <CModal opened={openedModalEdit} openModal={setModalEdit}>
            <AddRaport
              raport={selectedRaport}
              type={typesActionsRaports.EDIT_RAPORT}
              callback={callbackEdit}
            />
          </CModal>
          <CModal opened={openedModalAditional} openModal={setModalAditional}>
            <AddRaport
              raport={selectedRaport}
              type={typesActionsRaports.ADDITIONAL_DOCUMENT}
              callback={callbackAdditional}
            />
          </CModal>
          <CModal
            opened={openedModalPermissions}
            openModal={setModalPermissions}
          >
            <EditReportsPermissionsModal report={selectedRaport} />
          </CModal>
        </>
      )}
      {!initial_raports.data && <Skeleton />}
    </div>
  );
};

export default Raports;
